import { Card, CardBody, CardHeader, Badge } from "reactstrap";
import CardImageItem from "./CardImages";

const InspectionItem = ({ inspection }) => {
  const { status, name, description, fileName } = inspection || {};

  return (
    <Card>
      <CardHeader className="bg-info-subtle">
        <div className="d-flex justify-content-between align-items-center">
          <h5>{name || "-"}</h5>
          <Badge className="ms-2" color={status === "Oui" ? "success" : status === "Non" ? "danger" : "secondary"}>
            {status || "-"}
          </Badge>
        </div>
      </CardHeader>
      <CardBody className="p-4">
        <CardImageItem files={[fileName]} />
        <div className="text-muted">
          Description : {description || "Aucune description"}
        </div>
      </CardBody>
    </Card>
  );
};

export default InspectionItem;
